import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(160deg,#0d1117 0%,#13192b 60%,#0d1117 100%)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontFamily: 'Tajawal,sans-serif', direction: 'rtl', padding: 24,
      }}>
        <div style={{
          background: '#161c2d', border: '1px solid #334155',
          borderRadius: 20, padding: '32px 28px',
          maxWidth: 420, width: '100%', textAlign: 'center',
        }}>
          <div style={{ fontSize: 56, marginBottom: 16 }}>⚠️</div>
          <h2 style={{ color: '#fca5a5', fontSize: 22, fontWeight: 900, margin: '0 0 8px' }}>
            حدث خطأ غير متوقع
          </h2>
          <p style={{ color: '#6b7280', fontSize: 14, margin: '0 0 24px' }}>
            {this.state.error?.message || 'خطأ غير معروف'}
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              width: '100%', background: 'linear-gradient(135deg,#7c6df8,#a78bfa)',
              color: '#fff', border: 'none', borderRadius: 12,
              padding: 14, fontSize: 16, fontWeight: 700,
              cursor: 'pointer', fontFamily: 'Tajawal,sans-serif',
            }}
          >
            🔄 إعادة تحميل التطبيق
          </button>
        </div>
      </div>
    );
  }
}
